document.addEventListener('DOMContentLoaded', () => {
  const checkboxes = document.querySelectorAll('.js-checkbox-with-timestamp')

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', event => {
      const hiddenTimestampField = checkbox
        .closest('.checkbox-with-timestamp_container')
        .querySelector('.js-checkbox-timestamp-hidden')

      hiddenTimestampField.value = event.target.checked
        ? new Date().toISOString()
        : ''
    })
  })

  // Form validation for required checkboxes
  const form = document.querySelector('.js-stripe-form')
  if (form) {
    form.addEventListener('submit', event => {
      let valid = true

      checkboxes.forEach(checkbox => {
        const isRequired = checkbox.dataset.required === 'true'

        if (isRequired && !checkbox.checked) {
          valid = false
          checkbox.classList.add('text-error')
        } else {
          checkbox.classList.remove('text-error')
        }
      })

      if (!valid) {
        event.preventDefault()
      }
    })
  }
})
